export const CREATOR_OVERVIEW_MULTI_CREATOR = [
  { h: 1, type: 'HEADER', w: 6, x: 0, y: 0, meta: { name: 'Creators Performance - Instagram' } },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 0,
    y: 1,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 3,
    y: 1,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_ENGAGEMENTS_PUBLIC'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 5,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 5,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_COMMENTS'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 9,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_AVG_ENGAGEMENT_RATE_FOLLOWERS'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 9,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_LIKES'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 13,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_ENGAGEMENTS_PUBLIC'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 17,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_EMV'],
      sort_order: 'DESC',
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 21,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_EMV'],
      sort_order: 'ASC',
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 25,
    meta: { name: 'Creators Performance - Instagram Stories (Connected Creators Only)' },
  },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 0,
    y: 26,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 3,
    y: 26,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['AVG_REACH'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 30,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 30,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['AVG_COMPLETION_RATE'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 34,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['VIEWS'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 34,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['AVG_REACH'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 38,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['REACH'],
      sort_order: 'DESC',
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 42,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['EMV'],
      sort_order: 'DESC',
    },
  },
  { h: 1, type: 'HEADER', w: 6, x: 0, y: 46, meta: { name: 'Creators Performance - TikTok' } },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 0,
    y: 47,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 3,
    y: 47,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['VIDEO_VIEWS'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 51,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 51,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['COMMENTS'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 55,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['SHARES'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 55,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_LIKES'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 59,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['VIDEO_VIEWS'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 63,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_EMV'],
      sort_order: 'DESC',
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 67,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_EMV'],
      sort_order: 'ASC',
    },
  },
];
